module.exports = __webpack_public_path__ + "fonts/DIN-Alternate-Bold.2dbc231e.ttf";